module.exports = __webpack_public_path__ + "media/valentines_tipping_tier_3-21fa7048e10aa06d5a2afde1049b4dec.mp3";